export default "__VITE_ASSET__CvehVHPI__"